<script setup>
import TrainingPlanTable from '../components/TrainingPlanTable.vue';
import States from '../constants/States';
import TrainingTypes from '../constants/TrainingTypes';
import {APIService} from '@/core/util/services/api.service';
import {onMounted, ref, defineProps} from 'vue';

// Before
const props = defineProps({
  departments: {type: Array, default: null},
});

const http = new APIService(window.appGlobal.baseUrl, 'api/v2/pim/employees');

const employees = ref([]);

onMounted(async () => {
  await http
    .getAll({
      includeEmployees: 'onlyCurrent',
    })
    .then(response => {
      employees.value = response.data.data.map(employee => {
        return {
          id: employee.empNumber,
          label: `${employee.firstName} ${employee.middleName} ${employee.lastName}`,
        };
      });
    });
});
</script>
<template>
  <div class="orangehrm-background-container">
    <TrainingPlanTable>
      <template #default="{filters, onReset, onSubmit, subUnits}">
        <oxd-table-filter filter-title="Training List">
          <oxd-form @reset="onReset" @submit="onSubmit">
            <oxd-form-row>
              <oxd-grid :cols="5" class="orangehrm-full-width-grid">
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.owners"
                    label="Owner"
                    value="Select"
                    type="multiselect"
                    :options="employees"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.trainers"
                    label="Trainer"
                    value="Select"
                    type="multiselect"
                    :options="employees"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.assignes"
                    label="Assigned to"
                    value="Select"
                    type="multiselect"
                    :options="employees"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <date-input v-model="filters.startDate" label="Start Date" />
                </oxd-grid-item>
                <oxd-grid-item>
                  <date-input v-model="filters.dueDate" label="Due Date" />
                </oxd-grid-item>
              </oxd-grid>
              <oxd-grid :cols="5" class="orangehrm-full-width-grid">
                <oxd-grid-item>
                  <oxd-input-field v-model="filters.name" label="Training" />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.departments"
                    label="Department"
                    value="Select"
                    type="select"
                    :options="departments"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.subUnits"
                    label="Sub Unit"
                    value="Select"
                    type="multiselect"
                    :options="subUnits"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.types"
                    label="Types"
                    value="Select"
                    type="select"
                    :options="TrainingTypes"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.status"
                    label="Status"
                    value="Select"
                    type="multiselect"
                    :options="States"
                  />
                </oxd-grid-item>
              </oxd-grid>
            </oxd-form-row>

            <oxd-divider />

            <oxd-form-actions>
              <required-text />
              <oxd-button
                display-type="ghost"
                :label="$t('general.reset')"
                type="reset"
              />
              <oxd-button
                class="orangehrm-left-space"
                display-type="secondary"
                :label="$t('general.search')"
                type="submit"
              />
            </oxd-form-actions>
          </oxd-form>
        </oxd-table-filter>
      </template>
    </TrainingPlanTable>
  </div>
</template>
